/**
 * api/_template.js — frontend client for the foundation demo backend.
 *
 * Convention (SELFSERVE_MODULE_SPEC §17.2.f): every new Self-Serve
 * module gets its own `api/<module>.js` file. No fetch() calls live
 * in pages or App.js.
 */
import api from '../lib/api';

const base = '/_template';

export const listTemplateItems = ({ accountId, limit = 50, offset = 0 } = {}) =>
  api
    .get(`${base}/items`, { params: { account_id: accountId, limit, offset } })
    .then((r) => r.data);

export const createTemplateItem = ({ accountId, name, secret }) =>
  api
    .post(`${base}/items`, { name, secret }, { params: { account_id: accountId } })
    .then((r) => r.data);

export const getTemplateItemFull = ({ accountId, id }) =>
  api
    .get(`${base}/items/${id}/full`, { params: { account_id: accountId } })
    .then((r) => r.data);

export const patchTemplateItem = ({ accountId, id, name, secret }) =>
  api
    .patch(`${base}/items/${id}`, { name, secret }, { params: { account_id: accountId } })
    .then((r) => r.data);

export const deleteTemplateItem = ({ accountId, id }) =>
  api
    .delete(`${base}/items/${id}`, { params: { account_id: accountId } })
    .then((r) => r.data);
